import axios from './api.js'
import Vue from 'vue'

const state = {
    userInfo: {
        userId: null,
        name: null,
        phoneNumber: null,
        email: null,
        organizationId: null,
        organizationName: null,
        selectedOrganization: null,
        permissions: {
            requests: {
                enabled: false
            },
            tasks: {
                enabled: false
            },
            requisitions: {
                enabled: false,
                breakage: false
            },
            organization: {
                enabled: false
            },
            configdrive: {
                enabled: false
            },
            companies: {
                enabled: false
            }
        }
    },
    organizationList: [],
    applicationSettings: [],
    selectedOrganization: {},
    applicationList: [],
    portalAppKey: null,
    driveEndpoint: null,
    facilityEndpoint: null
}

const getters = {
    getUser: state => {
        const user = JSON.parse(JSON.stringify(state.userInfo))
        return user
    },
    getUserId: state => {
        return state.userInfo.userId
    },
    userInfo: state => {
        return state.userInfo
    },
    permissions: state => {
        return state.userInfo.permissions
    },
    organizationList: state => {
        return state.organizationList
    },
    getFirm: state => {
        const firm = JSON.parse(JSON.stringify(state.selectedOrganization))
        return firm
    },
    getSelectedOrganization: state => {
        return state.selectedOrganization
    },
    getApplicationList: state => {
        return state.applicationList
    },
    getApplicationSettings: state => {
        return state.applicationSettings
    },
    getPortalAppKey: state => {
        return state.portalAppKey
    },
    getDriveEndpoint: state => {
        return state.driveEndpoint
    },
    getFacilityEndpoint: state => {
        return state.facilityEndpoint
    }
}

const mutations = {
    errorHandler: (state, err) => {
        console.error('error', err)
    },
    successHandler: (state, status) => {
        console.log('success', status)
        return status
    },
    updatePermissions: (state, payload) => {
        state.userInfo.permissions = payload
    },
    setCurrentUserInfo: (state, payload) => {
        let key = Object.keys(payload)
        let val = Object.values(payload)
        for (let i in key) {
            state.userInfo[key[i]] = val[i]
        }
    },
    setCurrentOrganzationList: (state, payload) => {
        state.organizationList = payload
    },
    setSelectedOrganization: (state, payload) => {
        state.selectedOrganization = state.organizationList.filter(organization => organization.id === payload.toLowerCase())[0]
    },
    setApplicationList: (state, payload) => {
        let appObj = {}
        payload.forEach(app => {
            if (app.value.toLowerCase() === 'portal') {
                state.portalAppKey = app.key
            }
            appObj = {
                key: app.key,
                value: app.value,
                url: app.url,
                label: app.label,
                api: null,
                apiParameters: null,
                relevant: false
            }
            state.applicationList.push(appObj)
        })
    },
    setApplicationSettings: (state, payload) => {
        state.applicationSettings = payload

        payload.forEach((element) => {
            if (element.name === 'driveEndpoint') {
                state.driveEndpoint = element.value
            }
            if (element.name === 'facilityEndpoint') {
                state.facilityEndpoint = element.value
            }
        })
    },
    updateEmailSettings: (state, payload) => {
        console.log('updateEmailSettings', payload)
        console.log('state.application', state.applicationSettings)
        // state.application
    },
    setApplicationEndpoints: (state, payload) => {
        state.applicationList.forEach(app => {
            if (app.value === payload.value) {
                app.api = payload.data.httpEndPoint
                app.apiParameters = payload.data.idParameterName + '=' + payload.data.idParameterValue + '&' + payload.data.tokenParameterName + '=' + payload.data.tokenParameterValue
            }
        })
    }
}

const actions = {
    ping: ({commit}) => {
        return axios.get('/Account/Ping').then((response) => {
            return new Promise((resolve, reject) => {
                if (response.data.authenticated) {
                    resolve(true)
                } else {
                    resolve(false)
                }
            })
        })
    },
    signOut: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.post('/Account/SignOut').then((response) => {
                resolve(true)
            }, error => {
                commit('errorHandler', error)
                reject(error)
            })
        })
    },
    getCurrentOrganizationList: ({ commit }) => {
        return axios.post('/Account/GetOrganizationListForAllApplications').then((response) => {
            commit('setCurrentOrganzationList', response.data)
            return response.data
        }, (response) => {
            commit('errorHandler', response)
        }).then(response => {
            if (!Object.keys(state.selectedOrganization).length && state.userInfo.selectedOrganization) {
                commit('setSelectedOrganization', state.userInfo.selectedOrganization)
            }
            return response
        })
    },
    updateDriveUserEmailSetting: ({ commit }, emailSettingsObject) => {
        return axios.post('/Drive/UpdateDriveUserEmailSetting', emailSettingsObject).then((response) => {
            commit('updateEmailSettings', emailSettingsObject)
            return response.data
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    createDriveUser: ({ commit }, driveUserObject) => {
        return axios.post('/Drive/CreateDriveUser', driveUserObject).then((response) => {
            commit('errorHandler', response)
        })
    },
    setUserUiSettings: ({ commit }, uiSettingsObject) => {
        return axios.post('/Drive/UpdateDriveUserUiSetting', uiSettingsObject).then((response) => {
            commit('errorHandler', response)
        })
    },
    setUserProperties: ({ commit }, userProperties) => {
        let userPropertiesObject = {
            name: userProperties.name,
            phonenumber: userProperties.phoneNumber,
            email: userProperties.email
        }
        return axios.post('/Account/UpdateUserinfo', userPropertiesObject).then((response) => {
            commit('successHandler')
            commit('setCurrentUserInfo', userProperties)
            return response
        }, error => {
            let errorText = ''
            switch (error.response.data.ErrorCode) {
            case 4:
                errorText = 'En bruger med samme e-mail er allerede oprettet. Brug en anden e-mail'
                break
            default:
                errorText = 'Noget gik galt. Prøv venligst igen'
                break
            }
            Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: errorText})
            commit('errorHandler', error)
        })
    },
    createUpdateDataOwnerOrganization: ({ commit }, firm) => {
        let firmObject = {
            organizationId: firm.id,
            name: firm.name,
            email: firm.email,
            phoneNumber: firm.phoneNumber,
            address1: firm.address1,
            city: firm.city,
            postalCode: firm.postalCode
        }
        return axios.post('/UserAdmin/CreateUpdateOrganization', firmObject).then((response) => {
            commit('successHandler')
            state.selectedOrganization = response.data
            return response
        }, error => {
            commit('errorHandler', error)
        })
    },
    changeOrganizationContext: ({ commit }, organizationId) => {
        return axios.post('/Account/ChangeOrganizationContext', {organizationId: organizationId}).then((response) => {
            commit('successHandler')
            return response
        }, error => {
            commit('errorHandler', error)
        })
    },
    setSelectedOrganizationId: ({ commit }, organizationId) => {
        commit('setSelectedOrganization', organizationId)
    },
    getCurrentUserInfo: ({ commit, dispatch }) => {
        return axios.post('/Account/GetCurrentUserInfo').then((response) => {
            commit('setCurrentUserInfo', response.data)
            return (response.data)
        }, (response) => {
            commit('errorHandler', response)
            throw new Error(response)
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setCurrentUserRights'))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setApplicationList'))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('getApplicationSettings'))
            })
        }).then(() => {
            dispatch('getCurrentOrganizationList')
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setClearAssociatedOrganizationList'))
            })
        }).then(() => {
            if (state.userInfo.permissions.organization.enabled) {
                return new Promise((resolve, reject) => {
                    resolve(dispatch('setAssociatedOrganizationList'))
                })
            }
        }).then(() => {
            if (state.userInfo.permissions.organization.enabled) {
                dispatch('setAllOrganizationList')
            }
        }).catch((error) => {
            return error
        })
    },
    setApplicationList: ({ commit }) => {
        return axios.post('/Account/GetApplicationList').then((response) => {
            commit('setApplicationList', response.data)
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    getApplicationSettings: ({ commit }) => {
        return axios.post('/Account/GetApplicationSettings').then((response) => {
            commit('setApplicationSettings', response.data)
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    setApplicationEndpoints: ({ commit }, app) => {
        return new Promise((resolve, reject) => {
            resolve(axios.post('/Account/GetSignInToken', {applicationId: app.key}).then((response) => {
                commit('setApplicationEndpoints', {value: app.value, data: response.data})
                return response
            }, (response) => {
                commit('errorHandler', response)
                throw new Error(response)
            }).catch((error) => {
                Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: 'Der opstod et problem med at få adgang til produktet. Prøv venligst igen.'})
                return error
            }))
        }).then((response) => {
            return response
        })
    },
    setCurrentUserRights: ({ commit }) => {
        let q = {}
        q = {
            'userId': state.userInfo.userId,
            'organizationId': state.userInfo.organizationId
        }
        return axios.post('/Account/GetClaims', q).then((response) => {
            let permissions = {
                configdrive: {
                    enabled: false
                },
                requests: {
                    enabled: false
                },
                tasks: {
                    enabled: false
                },
                requisitions: {
                    enabled: false,
                    breakage: false
                },
                organization: {
                    enabled: false
                },
                companies: {
                    enabled: false
                }
            }
            response.data.forEach(item => {
                // SelectedOrganization
                if (item.type.toLowerCase() === 'selectedorganization') {
                    state.userInfo.selectedOrganization = item.value
                }
                // Portal
                if (item.type.toLowerCase() === 'portal.role') {
                    if (item.value.toLowerCase().indexOf('useradmin') !== -1) {
                        permissions.organization.enabled = true
                        // DRIVE
                        if (item.value.toLowerCase().indexOf('drive') !== -1) {
                            permissions.companies.enabled = true
                        }
                    }
                }
                // DRIVE
                if (item.type.toLowerCase() === 'drive.role') {
                    if (item.value.toLowerCase() === 'config') {
                        permissions.configdrive.enabled = true
                    }
                    if (item.value.toLowerCase() === 'report') {
                        permissions.requisitions.enabled = true
                    }
                    if (item.value.toLowerCase() === 'report') {
                        permissions.requisitions.enabled = true
                    }
                    let idx = item.value.indexOf('_')
                    if (idx > -1) {
                        let prefix = item.value.substring(0, idx)
                        if (prefix.toLowerCase() === 'task') {
                            permissions.tasks.enabled = true
                        } else if (prefix.toLowerCase() === 'request') {
                            permissions.requests.enabled = true
                        }
                    }
                }
            })
            commit('updatePermissions', permissions)
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    sendResetLink: ({ commit }) => {
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/global.js